import React from "react";
import { Image, Stack } from "react-bootstrap";
import PrimaryActionButton from "../../../components/Buttons/PrimaryActionButton/PrimaryActionButton";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../utils/constants";
import "./TopupStatusTemplate.scss";

interface TopupStatusTemplateProps {
  image: string;
  mainCopy: string;
  subCopy: string;
  showSecondaryCta?: boolean;
  primaryButtonText?: string;
  handlePrimaryAction?: () => void;
}

export default function TopupStatusTemplate({
  image,
  mainCopy,
  subCopy,
  handlePrimaryAction,
  showSecondaryCta = true,
  primaryButtonText = "Retry Top-up",
}: TopupStatusTemplateProps) {
  return (
    <div className="TopupStatusPage">
      <div className="d-flex flex-column justify-content-center MainContent">
        <div>
          <Image src={image} alt={mainCopy} width={70} height={70} />
        </div>
        <Stack gap={3} className="TopupDetails">
          <p className="Grotesk SpecialFontSettings MainCopy">{mainCopy}</p>
          <p className="Grotesk SpecialFontSettings SubCopy">{subCopy}</p>
        </Stack>
      </div>

      <Stack className="justify-content-end Ctas">
        <PrimaryActionButton
          text={primaryButtonText}
          textClassName="fw-bold PrimaryCta"
          onClick={handlePrimaryAction}
        />
        {showSecondaryCta && (
          <Link
            to={`${ROUTES.WALLET.ROOT}`}
            className="fs-6 fw-bold text-decoration-none Grotesk SecondaryCta"
          >
            Back to wallet
          </Link>
        )}
      </Stack>
    </div>
  );
}
